// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Rectangle } from "../../Commons/Geometry.js";
import { ToolView } from "./ToolView.js";

export let SymbolToolView = function (tool)
{
    ToolView.call(this, tool);
};

SymbolToolView.prototype = Object.create(ToolView.prototype);

SymbolToolView.prototype.IsSelectCheck = function (x, y)
{
    var symbolBmp = this.dataCacheTool.SymbolBmp;
    if (!symbolBmp) return false;

    var p = this.screenPoints[0];

    var rect = new Rectangle(
        p[0] - symbolBmp.width / 2,
        p[1] - symbolBmp.height / 2,
        symbolBmp.width,
        symbolBmp.height);

    return rect.Contains(x, y);
};

SymbolToolView.prototype.DrawSymbol = function (gr)
{
    var symbolBmp = this.dataCacheTool.SymbolBmp;
    if (!symbolBmp) return;

    var p = this.screenPoints[0];

    gr.drawImage(symbolBmp,
        p[0] - symbolBmp.width / 2,
        p[1] - symbolBmp.height / 2);
};

SymbolToolView.prototype.Draw = function (gr, ww, param)
{
    ToolView.prototype.Draw.call(this, gr, ww, param);
    this.DrawSymbol(gr);
};

SymbolToolView.prototype.DrawSelection = function (gr, ww)
{
    var symbolBmp = this.dataCacheTool.SymbolBmp;
    if (!symbolBmp) return;

    var p = this.screenPoints[0];
    var x = p[0];
    var y = p[1];

    var widthHalf = symbolBmp.width / 2;
    var heightHalf = symbolBmp.height / 2;

    this.DrawSelectedPoint(gr, ww, x - widthHalf, y - heightHalf);
    this.DrawSelectedPoint(gr, ww, x + widthHalf, y - heightHalf);
    this.DrawSelectedPoint(gr, ww, x - widthHalf, y + heightHalf);
    this.DrawSelectedPoint(gr, ww, x + widthHalf, y + heightHalf);
};